import React from 'react';
import { dummyClick, emptyFunction } from '../utilities';
import { WhiteLink } from '../buttons';

const AccountNav = ({
  notificationCount,
  onSignOutClick,
  t: {
    profile, notifications, settings, logOut
  }
}) => (
  <div className="a-user-menu xs-hide opened">
    <ul className="list-reset bg-black-4 m0 p3">
      <li>
        <WhiteLink
          path="/profile_edit"
          target="_blank"
          text={profile}
          onClick={emptyFunction}
        />
      </li>
      <li>
        <WhiteLink
          path="/notifications"
          target="_blank"
          className="mr3"
          text={notifications}
          onClick={emptyFunction}
        />
        <span className="white bg-red radius-1 px10">
          {notificationCount}
        </span>
      </li>
      <li>
        <WhiteLink
          path="/settings"
          target="_blank"
          text={settings}
          onClick={emptyFunction}
        />
      </li>
      <li>
        <WhiteLink
          text={logOut}
          onClick={onSignOutClick}
        />
      </li>
    </ul>
  </div>
);

AccountNav.defaultProps = {
  notificationCount: 0,
  onSignOutClick: dummyClick,
  t: {
    profile: 'EN profile',
    notifications: 'EN notifications',
    settings: 'EN settings',
    logOut: 'EN logOut'
  }
};

export default AccountNav;